import type { ReactNode } from 'react';
import React from 'react';

import { Heading } from 'components/Heading/Heading';

import './Breakdown.scss';

type BreakdownProps = {
  id: string;
  title: string;
  children: ReactNode;
};

const Breakdown = ({ children, title, id }: BreakdownProps) => (
  <section className="Breakdown" data-testid={`section_${id}`}>
    <div className="Breakdown-header">
      <Heading as="h2" size="medium" id={`${id}-title`}>
        {title}
      </Heading>
    </div>
    <div className="Breakdown-body">{children}</div>
  </section>
);

export { Breakdown };
